import FormGroupWrap from '@/library/components/form/helpers/FormGroupWrap';
import { FC, ReactNode } from 'react';
import { Input } from 'reactstrap';

type SwitchColorClassName =
  | 'primary-switch'
  | 'green-switch'
  | 'green-violet-switch'
  | 'green-orange-switch'
  | 'red-switch'
  | 'red-switch-unchecked'
  | 'dark-switch-unchecked'
  | 'dark-orange-switch'
  | 'blue-switch'
  | 'blue-green-switch'
  | 'blue-orange-switch'
  | 'orange-violet-switch'
  | 'violet-orange-switch'
  | 'violet-default-switch';

type SwitchProps = {
  name?: string;
  value?: boolean;
  onChange?: () => void;
  className?: string;
  switchClassName?: `${SwitchColorClassName}` | string;
  labelClassName?: string;
  label?: ReactNode;
  size?: 'xs' | 'sm' | 'lg';
  innerOnLabel?: ReactNode;
  innerOffLabel?: ReactNode;
  disabled?: boolean;
  dataCy?: string;
};

const Switch: FC<SwitchProps> = ({
  name,
  value,
  onChange,
  className = '',
  switchClassName = '',
  labelClassName = '',
  label,
  size = 'lg',
  innerOnLabel,
  innerOffLabel,
  disabled,
  dataCy
}) => {
  return (
    <FormGroupWrap className={`switch-wrapper ${className}`}>
      <div
        className={`d-flex align-items-center switch-slider ${switchClassName} ${size} ${
          disabled ? 'disabled pe-none' : ''
        }`}
      >
        {label && (
          <span
            className={`slide-label form-label ${value ? 'inactive' : ''} ${labelClassName} ${
              labelClassName.includes('me-') ? '' : 'me-2'
            }`}
          >
            {label}
          </span>
        )}
        <div className={`slider-wrap`} onClick={disabled ? () => {} : onChange} data-cy={dataCy}>
          <Input type="checkbox" checked={value ? true : false} name={name} readOnly />
          <span
            className={`slider round ${
              innerOffLabel && !value ? 'd-flex justify-content-end' : ''
            }`}
          >
            {innerOnLabel && value ? innerOnLabel : !value && innerOffLabel ? innerOffLabel : ''}
          </span>
        </div>
      </div>
    </FormGroupWrap>
  );
};

export default Switch;
